import { render } from "./spinner-component.vue?vue&type=template&id=08739970&scoped=true"
const script = {}

import "./spinner-component.vue?vue&type=style&index=0&id=08739970&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08739970"]])

export default __exports__